import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    background: 'url("/rh360-main-bg.png"), #01563c',
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    zIndex: theme.zIndex.app.splashScreen
  },
  logoBg: {
    position: "absolute",
    maxHeight: 520,
    maxWidth: 786,
    width: "100%",
    height: "auto",
    zIndex: 0,
    opacity: 0.7
  },
  greetingsWrapper: {
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    zIndex: 1
  },
  greetings: {
    overflow: "hidden",
    fontSize: 40,
    color: theme.palette.common.white,
    textAlign: "center"
  },
  greetingsWelcome: {
    position: "relative",
    transform: "translateY(100%)",
    animation: ".5s ease-out 0s 1 $toTop",
    animationFillMode: "forwards"
  },
  greetingsName: {
    position: "relative",
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    textTransform: "uppercase",
    transform: "translateY(-100%)",
    animation: ".5s ease-out 0.5s 1 $toBottom",
    animationFillMode: "forwards"
  },
  "@keyframes toTop": {
    "0%": {
      transform: "translateY(100%)"
    },
    "100%": {
      transform: "translateY(0)"
    }
  },
  "@keyframes toBottom": {
    "0%": {
      transform: "translateY(-100%)"
    },
    "100%": {
      transform: "translateY(0)"
    }
  }
}));
